import React from "react";
import { usePermission } from "@/utils/usePermission";
import type { permissionsList } from "@/router/types";
import { useAppSelector } from "@/utils/redux";
import Loading from "../pages/loading";

interface Props {
  fallBack: React.ReactNode;
  permissionList: (typeof permissionsList)[keyof typeof permissionsList][];
  children: React.ReactNode;
}
const UserCheckPermission: React.FC<Props> = ({ permissionList, fallBack, children }: Props) => {
  const isLoadingPermission = useAppSelector((state) => state.user.isLoadingPermission);
  const isGranted = usePermission(permissionList);
  if (isLoadingPermission) {
    return <Loading />;
  }
  return isGranted ? children : fallBack;
};
export default UserCheckPermission;
